import { render, staticRenderFns } from "./MARS.vue?vue&type=template&id=7e80a8e3&"
import script from "./MARS.vue?vue&type=script&lang=js&"
export * from "./MARS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports